import type { Dispatch } from 'redux';
import { createActions, handleActions } from 'redux-actions';

import type {
    IAppActions,
    IAppDispatch,
    IAppState,
    IAppStore,
} from './interfaces';

/* State */
export const appInitialState: IAppState = {
    trigger: new Date(),
    error: undefined,
};

/* Selectors */
export const appSelectors = ({ app }: IAppStore): IAppState => app;

/* Dispatch */
export const appDispatch = (dispatch: Dispatch): IAppDispatch => ({
    dispatchTriggerChange: () => dispatch(triggerChange()),
    dispatchErrorOccured: (details) => dispatch(errorOccured(details)),
});

/* Actions */
export const AppActions = createActions({
    triggerChange: () => undefined,
    errorOccured: (errorMessage?: string) => ({ error: errorMessage }),
});
export const { triggerChange, errorOccured }: IAppActions =
    AppActions as any as IAppActions;

/* Reducers */
export const appReducer = handleActions(
    {
        triggerChange: (state) => {
            return { ...state, trigger: new Date() };
        },
        '@@i18n/SET_LOCALE': (state) => {
            return { ...state, trigger: new Date() };
        },
        errorOccured: (state, action) => {
            const { error } = action.payload;
            return { ...state, error };
        },
    },
    appInitialState,
);
